__turbopack_context__.v({
  "active": "_7HEYDG_active",
  "aside": "_7HEYDG_aside",
  "bleed-layout": "_7HEYDG_bleed-layout",
  "bleed-screen": "_7HEYDG_bleed-screen",
  "body": "_7HEYDG_body",
  "bullet": "_7HEYDG_bullet",
  "bullets": "_7HEYDG_bullets",
  "button": "_7HEYDG_button",
  "button-secondary": "_7HEYDG_button-secondary",
  "button-tertiary": "_7HEYDG_button-tertiary",
  "container": "_7HEYDG_container",
  "db": "_7HEYDG_db",
  "db-l": "_7HEYDG_db-l",
  "db-m": "_7HEYDG_db-m",
  "db-ns": "_7HEYDG_db-ns",
  "di": "_7HEYDG_di",
  "di-l": "_7HEYDG_di-l",
  "di-m": "_7HEYDG_di-m",
  "di-ns": "_7HEYDG_di-ns",
  "dib": "_7HEYDG_dib",
  "dib-l": "_7HEYDG_dib-l",
  "dib-m": "_7HEYDG_dib-m",
  "dib-ns": "_7HEYDG_dib-ns",
  "dit": "_7HEYDG_dit",
  "dit-l": "_7HEYDG_dit-l",
  "dit-m": "_7HEYDG_dit-m",
  "dit-ns": "_7HEYDG_dit-ns",
  "dn": "_7HEYDG_dn",
  "dn-l": "_7HEYDG_dn-l",
  "dn-m": "_7HEYDG_dn-m",
  "dn-ns": "_7HEYDG_dn-ns",
  "dt": "_7HEYDG_dt",
  "dt--fixed": "_7HEYDG_dt--fixed",
  "dt--fixed-l": "_7HEYDG_dt--fixed-l",
  "dt--fixed-m": "_7HEYDG_dt--fixed-m",
  "dt--fixed-ns": "_7HEYDG_dt--fixed-ns",
  "dt-column": "_7HEYDG_dt-column",
  "dt-column-group": "_7HEYDG_dt-column-group",
  "dt-column-group-l": "_7HEYDG_dt-column-group-l",
  "dt-column-group-m": "_7HEYDG_dt-column-group-m",
  "dt-column-group-ns": "_7HEYDG_dt-column-group-ns",
  "dt-column-l": "_7HEYDG_dt-column-l",
  "dt-column-m": "_7HEYDG_dt-column-m",
  "dt-column-ns": "_7HEYDG_dt-column-ns",
  "dt-l": "_7HEYDG_dt-l",
  "dt-m": "_7HEYDG_dt-m",
  "dt-ns": "_7HEYDG_dt-ns",
  "dt-row": "_7HEYDG_dt-row",
  "dt-row-group": "_7HEYDG_dt-row-group",
  "dt-row-group-l": "_7HEYDG_dt-row-group-l",
  "dt-row-group-m": "_7HEYDG_dt-row-group-m",
  "dt-row-group-ns": "_7HEYDG_dt-row-group-ns",
  "dt-row-l": "_7HEYDG_dt-row-l",
  "dt-row-m": "_7HEYDG_dt-row-m",
  "dt-row-ns": "_7HEYDG_dt-row-ns",
  "dtc": "_7HEYDG_dtc",
  "dtc-l": "_7HEYDG_dtc-l",
  "dtc-m": "_7HEYDG_dtc-m",
  "dtc-ns": "_7HEYDG_dtc-ns",
  "grid": "_7HEYDG_grid",
  "head": "_7HEYDG_head",
  "info": "_7HEYDG_info",
  "label": "_7HEYDG_label",
  "ma0": "_7HEYDG_ma0",
  "ma0-l": "_7HEYDG_ma0-l",
  "ma0-m": "_7HEYDG_ma0-m",
  "ma0-ns": "_7HEYDG_ma0-ns",
  "ma1": "_7HEYDG_ma1",
  "ma1-l": "_7HEYDG_ma1-l",
  "ma1-m": "_7HEYDG_ma1-m",
  "ma1-ns": "_7HEYDG_ma1-ns",
  "ma2": "_7HEYDG_ma2",
  "ma2-l": "_7HEYDG_ma2-l",
  "ma2-m": "_7HEYDG_ma2-m",
  "ma2-ns": "_7HEYDG_ma2-ns",
  "ma3": "_7HEYDG_ma3",
  "ma3-l": "_7HEYDG_ma3-l",
  "ma3-m": "_7HEYDG_ma3-m",
  "ma3-ns": "_7HEYDG_ma3-ns",
  "ma4": "_7HEYDG_ma4",
  "ma4-l": "_7HEYDG_ma4-l",
  "ma4-m": "_7HEYDG_ma4-m",
  "ma4-ns": "_7HEYDG_ma4-ns",
  "ma5": "_7HEYDG_ma5",
  "ma5-l": "_7HEYDG_ma5-l",
  "ma5-m": "_7HEYDG_ma5-m",
  "ma5-ns": "_7HEYDG_ma5-ns",
  "ma6": "_7HEYDG_ma6",
  "ma6-l": "_7HEYDG_ma6-l",
  "ma6-m": "_7HEYDG_ma6-m",
  "ma6-ns": "_7HEYDG_ma6-ns",
  "ma7": "_7HEYDG_ma7",
  "ma7-l": "_7HEYDG_ma7-l",
  "ma7-m": "_7HEYDG_ma7-m",
  "ma7-ns": "_7HEYDG_ma7-ns",
  "mb0": "_7HEYDG_mb0",
  "mb0-l": "_7HEYDG_mb0-l",
  "mb0-m": "_7HEYDG_mb0-m",
  "mb0-ns": "_7HEYDG_mb0-ns",
  "mb1": "_7HEYDG_mb1",
  "mb1-l": "_7HEYDG_mb1-l",
  "mb1-m": "_7HEYDG_mb1-m",
  "mb1-ns": "_7HEYDG_mb1-ns",
  "mb2": "_7HEYDG_mb2",
  "mb2-l": "_7HEYDG_mb2-l",
  "mb2-m": "_7HEYDG_mb2-m",
  "mb2-ns": "_7HEYDG_mb2-ns",
  "mb3": "_7HEYDG_mb3",
  "mb3-l": "_7HEYDG_mb3-l",
  "mb3-m": "_7HEYDG_mb3-m",
  "mb3-ns": "_7HEYDG_mb3-ns",
  "mb4": "_7HEYDG_mb4",
  "mb4-l": "_7HEYDG_mb4-l",
  "mb4-m": "_7HEYDG_mb4-m",
  "mb4-ns": "_7HEYDG_mb4-ns",
  "mb5": "_7HEYDG_mb5",
  "mb5-l": "_7HEYDG_mb5-l",
  "mb5-m": "_7HEYDG_mb5-m",
  "mb5-ns": "_7HEYDG_mb5-ns",
  "mb6": "_7HEYDG_mb6",
  "mb6-l": "_7HEYDG_mb6-l",
  "mb6-m": "_7HEYDG_mb6-m",
  "mb6-ns": "_7HEYDG_mb6-ns",
  "mb7": "_7HEYDG_mb7",
  "mb7-l": "_7HEYDG_mb7-l",
  "mb7-m": "_7HEYDG_mb7-m",
  "mb7-ns": "_7HEYDG_mb7-ns",
  "mh0": "_7HEYDG_mh0",
  "mh0-l": "_7HEYDG_mh0-l",
  "mh0-m": "_7HEYDG_mh0-m",
  "mh0-ns": "_7HEYDG_mh0-ns",
  "mh1": "_7HEYDG_mh1",
  "mh1-l": "_7HEYDG_mh1-l",
  "mh1-m": "_7HEYDG_mh1-m",
  "mh1-ns": "_7HEYDG_mh1-ns",
  "mh2": "_7HEYDG_mh2",
  "mh2-l": "_7HEYDG_mh2-l",
  "mh2-m": "_7HEYDG_mh2-m",
  "mh2-ns": "_7HEYDG_mh2-ns",
  "mh3": "_7HEYDG_mh3",
  "mh3-l": "_7HEYDG_mh3-l",
  "mh3-m": "_7HEYDG_mh3-m",
  "mh3-ns": "_7HEYDG_mh3-ns",
  "mh4": "_7HEYDG_mh4",
  "mh4-l": "_7HEYDG_mh4-l",
  "mh4-m": "_7HEYDG_mh4-m",
  "mh4-ns": "_7HEYDG_mh4-ns",
  "mh5": "_7HEYDG_mh5",
  "mh5-l": "_7HEYDG_mh5-l",
  "mh5-m": "_7HEYDG_mh5-m",
  "mh5-ns": "_7HEYDG_mh5-ns",
  "mh6": "_7HEYDG_mh6",
  "mh6-l": "_7HEYDG_mh6-l",
  "mh6-m": "_7HEYDG_mh6-m",
  "mh6-ns": "_7HEYDG_mh6-ns",
  "mh7": "_7HEYDG_mh7",
  "mh7-l": "_7HEYDG_mh7-l",
  "mh7-m": "_7HEYDG_mh7-m",
  "mh7-ns": "_7HEYDG_mh7-ns",
  "ml0": "_7HEYDG_ml0",
  "ml0-l": "_7HEYDG_ml0-l",
  "ml0-m": "_7HEYDG_ml0-m",
  "ml0-ns": "_7HEYDG_ml0-ns",
  "ml1": "_7HEYDG_ml1",
  "ml1-l": "_7HEYDG_ml1-l",
  "ml1-m": "_7HEYDG_ml1-m",
  "ml1-ns": "_7HEYDG_ml1-ns",
  "ml2": "_7HEYDG_ml2",
  "ml2-l": "_7HEYDG_ml2-l",
  "ml2-m": "_7HEYDG_ml2-m",
  "ml2-ns": "_7HEYDG_ml2-ns",
  "ml3": "_7HEYDG_ml3",
  "ml3-l": "_7HEYDG_ml3-l",
  "ml3-m": "_7HEYDG_ml3-m",
  "ml3-ns": "_7HEYDG_ml3-ns",
  "ml4": "_7HEYDG_ml4",
  "ml4-l": "_7HEYDG_ml4-l",
  "ml4-m": "_7HEYDG_ml4-m",
  "ml4-ns": "_7HEYDG_ml4-ns",
  "ml5": "_7HEYDG_ml5",
  "ml5-l": "_7HEYDG_ml5-l",
  "ml5-m": "_7HEYDG_ml5-m",
  "ml5-ns": "_7HEYDG_ml5-ns",
  "ml6": "_7HEYDG_ml6",
  "ml6-l": "_7HEYDG_ml6-l",
  "ml6-m": "_7HEYDG_ml6-m",
  "ml6-ns": "_7HEYDG_ml6-ns",
  "ml7": "_7HEYDG_ml7",
  "ml7-l": "_7HEYDG_ml7-l",
  "ml7-m": "_7HEYDG_ml7-m",
  "ml7-ns": "_7HEYDG_ml7-ns",
  "mr0": "_7HEYDG_mr0",
  "mr0-l": "_7HEYDG_mr0-l",
  "mr0-m": "_7HEYDG_mr0-m",
  "mr0-ns": "_7HEYDG_mr0-ns",
  "mr1": "_7HEYDG_mr1",
  "mr1-l": "_7HEYDG_mr1-l",
  "mr1-m": "_7HEYDG_mr1-m",
  "mr1-ns": "_7HEYDG_mr1-ns",
  "mr2": "_7HEYDG_mr2",
  "mr2-l": "_7HEYDG_mr2-l",
  "mr2-m": "_7HEYDG_mr2-m",
  "mr2-ns": "_7HEYDG_mr2-ns",
  "mr3": "_7HEYDG_mr3",
  "mr3-l": "_7HEYDG_mr3-l",
  "mr3-m": "_7HEYDG_mr3-m",
  "mr3-ns": "_7HEYDG_mr3-ns",
  "mr4": "_7HEYDG_mr4",
  "mr4-l": "_7HEYDG_mr4-l",
  "mr4-m": "_7HEYDG_mr4-m",
  "mr4-ns": "_7HEYDG_mr4-ns",
  "mr5": "_7HEYDG_mr5",
  "mr5-l": "_7HEYDG_mr5-l",
  "mr5-m": "_7HEYDG_mr5-m",
  "mr5-ns": "_7HEYDG_mr5-ns",
  "mr6": "_7HEYDG_mr6",
  "mr6-l": "_7HEYDG_mr6-l",
  "mr6-m": "_7HEYDG_mr6-m",
  "mr6-ns": "_7HEYDG_mr6-ns",
  "mr7": "_7HEYDG_mr7",
  "mr7-l": "_7HEYDG_mr7-l",
  "mr7-m": "_7HEYDG_mr7-m",
  "mr7-ns": "_7HEYDG_mr7-ns",
  "mt0": "_7HEYDG_mt0",
  "mt0-l": "_7HEYDG_mt0-l",
  "mt0-m": "_7HEYDG_mt0-m",
  "mt0-ns": "_7HEYDG_mt0-ns",
  "mt1": "_7HEYDG_mt1",
  "mt1-l": "_7HEYDG_mt1-l",
  "mt1-m": "_7HEYDG_mt1-m",
  "mt1-ns": "_7HEYDG_mt1-ns",
  "mt2": "_7HEYDG_mt2",
  "mt2-l": "_7HEYDG_mt2-l",
  "mt2-m": "_7HEYDG_mt2-m",
  "mt2-ns": "_7HEYDG_mt2-ns",
  "mt3": "_7HEYDG_mt3",
  "mt3-l": "_7HEYDG_mt3-l",
  "mt3-m": "_7HEYDG_mt3-m",
  "mt3-ns": "_7HEYDG_mt3-ns",
  "mt4": "_7HEYDG_mt4",
  "mt4-l": "_7HEYDG_mt4-l",
  "mt4-m": "_7HEYDG_mt4-m",
  "mt4-ns": "_7HEYDG_mt4-ns",
  "mt5": "_7HEYDG_mt5",
  "mt5-l": "_7HEYDG_mt5-l",
  "mt5-m": "_7HEYDG_mt5-m",
  "mt5-ns": "_7HEYDG_mt5-ns",
  "mt6": "_7HEYDG_mt6",
  "mt6-l": "_7HEYDG_mt6-l",
  "mt6-m": "_7HEYDG_mt6-m",
  "mt6-ns": "_7HEYDG_mt6-ns",
  "mt7": "_7HEYDG_mt7",
  "mt7-l": "_7HEYDG_mt7-l",
  "mt7-m": "_7HEYDG_mt7-m",
  "mt7-ns": "_7HEYDG_mt7-ns",
  "mv0": "_7HEYDG_mv0",
  "mv0-l": "_7HEYDG_mv0-l",
  "mv0-m": "_7HEYDG_mv0-m",
  "mv0-ns": "_7HEYDG_mv0-ns",
  "mv1": "_7HEYDG_mv1",
  "mv1-l": "_7HEYDG_mv1-l",
  "mv1-m": "_7HEYDG_mv1-m",
  "mv1-ns": "_7HEYDG_mv1-ns",
  "mv2": "_7HEYDG_mv2",
  "mv2-l": "_7HEYDG_mv2-l",
  "mv2-m": "_7HEYDG_mv2-m",
  "mv2-ns": "_7HEYDG_mv2-ns",
  "mv3": "_7HEYDG_mv3",
  "mv3-l": "_7HEYDG_mv3-l",
  "mv3-m": "_7HEYDG_mv3-m",
  "mv3-ns": "_7HEYDG_mv3-ns",
  "mv4": "_7HEYDG_mv4",
  "mv4-l": "_7HEYDG_mv4-l",
  "mv4-m": "_7HEYDG_mv4-m",
  "mv4-ns": "_7HEYDG_mv4-ns",
  "mv5": "_7HEYDG_mv5",
  "mv5-l": "_7HEYDG_mv5-l",
  "mv5-m": "_7HEYDG_mv5-m",
  "mv5-ns": "_7HEYDG_mv5-ns",
  "mv6": "_7HEYDG_mv6",
  "mv6-l": "_7HEYDG_mv6-l",
  "mv6-m": "_7HEYDG_mv6-m",
  "mv6-ns": "_7HEYDG_mv6-ns",
  "mv7": "_7HEYDG_mv7",
  "mv7-l": "_7HEYDG_mv7-l",
  "mv7-m": "_7HEYDG_mv7-m",
  "mv7-ns": "_7HEYDG_mv7-ns",
  "numeric": "_7HEYDG_numeric",
  "numeric-wrap": "_7HEYDG_numeric-wrap",
  "pa0": "_7HEYDG_pa0",
  "pa0-l": "_7HEYDG_pa0-l",
  "pa0-m": "_7HEYDG_pa0-m",
  "pa0-ns": "_7HEYDG_pa0-ns",
  "pa1": "_7HEYDG_pa1",
  "pa1-l": "_7HEYDG_pa1-l",
  "pa1-m": "_7HEYDG_pa1-m",
  "pa1-ns": "_7HEYDG_pa1-ns",
  "pa2": "_7HEYDG_pa2",
  "pa2-l": "_7HEYDG_pa2-l",
  "pa2-m": "_7HEYDG_pa2-m",
  "pa2-ns": "_7HEYDG_pa2-ns",
  "pa3": "_7HEYDG_pa3",
  "pa3-l": "_7HEYDG_pa3-l",
  "pa3-m": "_7HEYDG_pa3-m",
  "pa3-ns": "_7HEYDG_pa3-ns",
  "pa4": "_7HEYDG_pa4",
  "pa4-l": "_7HEYDG_pa4-l",
  "pa4-m": "_7HEYDG_pa4-m",
  "pa4-ns": "_7HEYDG_pa4-ns",
  "pa5": "_7HEYDG_pa5",
  "pa5-l": "_7HEYDG_pa5-l",
  "pa5-m": "_7HEYDG_pa5-m",
  "pa5-ns": "_7HEYDG_pa5-ns",
  "pa6": "_7HEYDG_pa6",
  "pa6-l": "_7HEYDG_pa6-l",
  "pa6-m": "_7HEYDG_pa6-m",
  "pa6-ns": "_7HEYDG_pa6-ns",
  "pa7": "_7HEYDG_pa7",
  "pa7-l": "_7HEYDG_pa7-l",
  "pa7-m": "_7HEYDG_pa7-m",
  "pa7-ns": "_7HEYDG_pa7-ns",
  "pb0": "_7HEYDG_pb0",
  "pb0-l": "_7HEYDG_pb0-l",
  "pb0-m": "_7HEYDG_pb0-m",
  "pb0-ns": "_7HEYDG_pb0-ns",
  "pb1": "_7HEYDG_pb1",
  "pb1-l": "_7HEYDG_pb1-l",
  "pb1-m": "_7HEYDG_pb1-m",
  "pb1-ns": "_7HEYDG_pb1-ns",
  "pb2": "_7HEYDG_pb2",
  "pb2-l": "_7HEYDG_pb2-l",
  "pb2-m": "_7HEYDG_pb2-m",
  "pb2-ns": "_7HEYDG_pb2-ns",
  "pb3": "_7HEYDG_pb3",
  "pb3-l": "_7HEYDG_pb3-l",
  "pb3-m": "_7HEYDG_pb3-m",
  "pb3-ns": "_7HEYDG_pb3-ns",
  "pb4": "_7HEYDG_pb4",
  "pb4-l": "_7HEYDG_pb4-l",
  "pb4-m": "_7HEYDG_pb4-m",
  "pb4-ns": "_7HEYDG_pb4-ns",
  "pb5": "_7HEYDG_pb5",
  "pb5-l": "_7HEYDG_pb5-l",
  "pb5-m": "_7HEYDG_pb5-m",
  "pb5-ns": "_7HEYDG_pb5-ns",
  "pb6": "_7HEYDG_pb6",
  "pb6-l": "_7HEYDG_pb6-l",
  "pb6-m": "_7HEYDG_pb6-m",
  "pb6-ns": "_7HEYDG_pb6-ns",
  "pb7": "_7HEYDG_pb7",
  "pb7-l": "_7HEYDG_pb7-l",
  "pb7-m": "_7HEYDG_pb7-m",
  "pb7-ns": "_7HEYDG_pb7-ns",
  "ph0": "_7HEYDG_ph0",
  "ph0-l": "_7HEYDG_ph0-l",
  "ph0-m": "_7HEYDG_ph0-m",
  "ph0-ns": "_7HEYDG_ph0-ns",
  "ph1": "_7HEYDG_ph1",
  "ph1-l": "_7HEYDG_ph1-l",
  "ph1-m": "_7HEYDG_ph1-m",
  "ph1-ns": "_7HEYDG_ph1-ns",
  "ph2": "_7HEYDG_ph2",
  "ph2-l": "_7HEYDG_ph2-l",
  "ph2-m": "_7HEYDG_ph2-m",
  "ph2-ns": "_7HEYDG_ph2-ns",
  "ph3": "_7HEYDG_ph3",
  "ph3-l": "_7HEYDG_ph3-l",
  "ph3-m": "_7HEYDG_ph3-m",
  "ph3-ns": "_7HEYDG_ph3-ns",
  "ph4": "_7HEYDG_ph4",
  "ph4-l": "_7HEYDG_ph4-l",
  "ph4-m": "_7HEYDG_ph4-m",
  "ph4-ns": "_7HEYDG_ph4-ns",
  "ph5": "_7HEYDG_ph5",
  "ph5-l": "_7HEYDG_ph5-l",
  "ph5-m": "_7HEYDG_ph5-m",
  "ph5-ns": "_7HEYDG_ph5-ns",
  "ph6": "_7HEYDG_ph6",
  "ph6-l": "_7HEYDG_ph6-l",
  "ph6-m": "_7HEYDG_ph6-m",
  "ph6-ns": "_7HEYDG_ph6-ns",
  "ph7": "_7HEYDG_ph7",
  "ph7-l": "_7HEYDG_ph7-l",
  "ph7-m": "_7HEYDG_ph7-m",
  "ph7-ns": "_7HEYDG_ph7-ns",
  "picture": "_7HEYDG_picture",
  "pl0": "_7HEYDG_pl0",
  "pl0-l": "_7HEYDG_pl0-l",
  "pl0-m": "_7HEYDG_pl0-m",
  "pl0-ns": "_7HEYDG_pl0-ns",
  "pl1": "_7HEYDG_pl1",
  "pl1-l": "_7HEYDG_pl1-l",
  "pl1-m": "_7HEYDG_pl1-m",
  "pl1-ns": "_7HEYDG_pl1-ns",
  "pl2": "_7HEYDG_pl2",
  "pl2-l": "_7HEYDG_pl2-l",
  "pl2-m": "_7HEYDG_pl2-m",
  "pl2-ns": "_7HEYDG_pl2-ns",
  "pl3": "_7HEYDG_pl3",
  "pl3-l": "_7HEYDG_pl3-l",
  "pl3-m": "_7HEYDG_pl3-m",
  "pl3-ns": "_7HEYDG_pl3-ns",
  "pl4": "_7HEYDG_pl4",
  "pl4-l": "_7HEYDG_pl4-l",
  "pl4-m": "_7HEYDG_pl4-m",
  "pl4-ns": "_7HEYDG_pl4-ns",
  "pl5": "_7HEYDG_pl5",
  "pl5-l": "_7HEYDG_pl5-l",
  "pl5-m": "_7HEYDG_pl5-m",
  "pl5-ns": "_7HEYDG_pl5-ns",
  "pl6": "_7HEYDG_pl6",
  "pl6-l": "_7HEYDG_pl6-l",
  "pl6-m": "_7HEYDG_pl6-m",
  "pl6-ns": "_7HEYDG_pl6-ns",
  "pl7": "_7HEYDG_pl7",
  "pl7-l": "_7HEYDG_pl7-l",
  "pl7-m": "_7HEYDG_pl7-m",
  "pl7-ns": "_7HEYDG_pl7-ns",
  "pr0": "_7HEYDG_pr0",
  "pr0-l": "_7HEYDG_pr0-l",
  "pr0-m": "_7HEYDG_pr0-m",
  "pr0-ns": "_7HEYDG_pr0-ns",
  "pr1": "_7HEYDG_pr1",
  "pr1-l": "_7HEYDG_pr1-l",
  "pr1-m": "_7HEYDG_pr1-m",
  "pr1-ns": "_7HEYDG_pr1-ns",
  "pr2": "_7HEYDG_pr2",
  "pr2-l": "_7HEYDG_pr2-l",
  "pr2-m": "_7HEYDG_pr2-m",
  "pr2-ns": "_7HEYDG_pr2-ns",
  "pr3": "_7HEYDG_pr3",
  "pr3-l": "_7HEYDG_pr3-l",
  "pr3-m": "_7HEYDG_pr3-m",
  "pr3-ns": "_7HEYDG_pr3-ns",
  "pr4": "_7HEYDG_pr4",
  "pr4-l": "_7HEYDG_pr4-l",
  "pr4-m": "_7HEYDG_pr4-m",
  "pr4-ns": "_7HEYDG_pr4-ns",
  "pr5": "_7HEYDG_pr5",
  "pr5-l": "_7HEYDG_pr5-l",
  "pr5-m": "_7HEYDG_pr5-m",
  "pr5-ns": "_7HEYDG_pr5-ns",
  "pr6": "_7HEYDG_pr6",
  "pr6-l": "_7HEYDG_pr6-l",
  "pr6-m": "_7HEYDG_pr6-m",
  "pr6-ns": "_7HEYDG_pr6-ns",
  "pr7": "_7HEYDG_pr7",
  "pr7-l": "_7HEYDG_pr7-l",
  "pr7-m": "_7HEYDG_pr7-m",
  "pr7-ns": "_7HEYDG_pr7-ns",
  "pt0": "_7HEYDG_pt0",
  "pt0-l": "_7HEYDG_pt0-l",
  "pt0-m": "_7HEYDG_pt0-m",
  "pt0-ns": "_7HEYDG_pt0-ns",
  "pt1": "_7HEYDG_pt1",
  "pt1-l": "_7HEYDG_pt1-l",
  "pt1-m": "_7HEYDG_pt1-m",
  "pt1-ns": "_7HEYDG_pt1-ns",
  "pt2": "_7HEYDG_pt2",
  "pt2-l": "_7HEYDG_pt2-l",
  "pt2-m": "_7HEYDG_pt2-m",
  "pt2-ns": "_7HEYDG_pt2-ns",
  "pt3": "_7HEYDG_pt3",
  "pt3-l": "_7HEYDG_pt3-l",
  "pt3-m": "_7HEYDG_pt3-m",
  "pt3-ns": "_7HEYDG_pt3-ns",
  "pt4": "_7HEYDG_pt4",
  "pt4-l": "_7HEYDG_pt4-l",
  "pt4-m": "_7HEYDG_pt4-m",
  "pt4-ns": "_7HEYDG_pt4-ns",
  "pt5": "_7HEYDG_pt5",
  "pt5-l": "_7HEYDG_pt5-l",
  "pt5-m": "_7HEYDG_pt5-m",
  "pt5-ns": "_7HEYDG_pt5-ns",
  "pt6": "_7HEYDG_pt6",
  "pt6-l": "_7HEYDG_pt6-l",
  "pt6-m": "_7HEYDG_pt6-m",
  "pt6-ns": "_7HEYDG_pt6-ns",
  "pt7": "_7HEYDG_pt7",
  "pt7-l": "_7HEYDG_pt7-l",
  "pt7-m": "_7HEYDG_pt7-m",
  "pt7-ns": "_7HEYDG_pt7-ns",
  "pv0": "_7HEYDG_pv0",
  "pv0-l": "_7HEYDG_pv0-l",
  "pv0-m": "_7HEYDG_pv0-m",
  "pv0-ns": "_7HEYDG_pv0-ns",
  "pv1": "_7HEYDG_pv1",
  "pv1-l": "_7HEYDG_pv1-l",
  "pv1-m": "_7HEYDG_pv1-m",
  "pv1-ns": "_7HEYDG_pv1-ns",
  "pv2": "_7HEYDG_pv2",
  "pv2-l": "_7HEYDG_pv2-l",
  "pv2-m": "_7HEYDG_pv2-m",
  "pv2-ns": "_7HEYDG_pv2-ns",
  "pv3": "_7HEYDG_pv3",
  "pv3-l": "_7HEYDG_pv3-l",
  "pv3-m": "_7HEYDG_pv3-m",
  "pv3-ns": "_7HEYDG_pv3-ns",
  "pv4": "_7HEYDG_pv4",
  "pv4-l": "_7HEYDG_pv4-l",
  "pv4-m": "_7HEYDG_pv4-m",
  "pv4-ns": "_7HEYDG_pv4-ns",
  "pv5": "_7HEYDG_pv5",
  "pv5-l": "_7HEYDG_pv5-l",
  "pv5-m": "_7HEYDG_pv5-m",
  "pv5-ns": "_7HEYDG_pv5-ns",
  "pv6": "_7HEYDG_pv6",
  "pv6-l": "_7HEYDG_pv6-l",
  "pv6-m": "_7HEYDG_pv6-m",
  "pv6-ns": "_7HEYDG_pv6-ns",
  "pv7": "_7HEYDG_pv7",
  "pv7-l": "_7HEYDG_pv7-l",
  "pv7-m": "_7HEYDG_pv7-m",
  "pv7-ns": "_7HEYDG_pv7-ns",
  "sections-list": "_7HEYDG_sections-list",
  "site-accordion": "_7HEYDG_site-accordion",
  "swiper-pagination": "_7HEYDG_swiper-pagination",
  "swiper-pagination-bullet": "_7HEYDG_swiper-pagination-bullet",
  "text-columns": "_7HEYDG_text-columns",
  "title": "_7HEYDG_title",
  "with-1": "_7HEYDG_with-1",
  "with-2": "_7HEYDG_with-2",
  "with-2-columns": "_7HEYDG_with-2-columns",
  "with-3": "_7HEYDG_with-3",
  "with-3-columns": "_7HEYDG_with-3-columns",
  "with-4": "_7HEYDG_with-4",
  "with-border": "_7HEYDG_with-border",
  "with-border-figure": "_7HEYDG_with-border-figure",
  "with-bullets": "_7HEYDG_with-bullets",
  "with-head-th": "_7HEYDG_with-head-th",
  "with-layout-fixed": "_7HEYDG_with-layout-fixed",
  "with-no-border": "_7HEYDG_with-no-border",
  "with-numeric": "_7HEYDG_with-numeric",
  "with-row": "_7HEYDG_with-row",
  "with-td-border": "_7HEYDG_with-td-border",
  "with-td-dashed": "_7HEYDG_with-td-dashed",
  "with-td-pa2": "_7HEYDG_with-td-pa2",
  "with-td-pa3": "_7HEYDG_with-td-pa3",
  "with-td-pv2": "_7HEYDG_with-td-pv2",
  "with-td-pv3": "_7HEYDG_with-td-pv3",
  "with-tr-border": "_7HEYDG_with-tr-border",
  "with-tr-dashed": "_7HEYDG_with-tr-dashed",
});
